// src/listeners/TransferSessionListener.ts
import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import useStore from "@src/stores/store";
import {db} from "@src/services/db";
import "@src/services/echo";
import MessageService from "@src/services/message";
import NotificationsService from "@src/services/notifications";

export const TransferSessionListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const store = useStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets.private(`user.${userId}`)
        .listen(".TransferSessionEvent", async (event: any) => {
            try {
                const session = event?.session;
                if (!session?.id) return;

                // busca o histórico completo da sessão agora que ela virou humana
                const resp = await MessageService.getSessionMessagesOld(session.id);

                const messages = Array.isArray(resp?.data)
                    ? resp.data.map((message: any) => ({
                        ...message,
                        chat_session_id: Number(message.chat_session_id ?? session.id),
                    }))
                    : [];

                const wasSelected = Number((sessionStore.selectedSession as any)?.id) === session.id;
                const hasNewMessage = !wasSelected;

                await db.transaction("rw", db.sessions, db.messages, async () => {
                    if (messages.length > 0) {
                        await db.messages.bulkPut(messages);
                    }

                    await db.sessions.put({
                        ...session,
                        status: "active",
                        is_archive: false,
                        updated_at: new Date().toISOString(),
                        has_new_messages: hasNewMessage,
                    } as any);
                });

                if (hasNewMessage) {
                    NotificationsService.notify('Um atendimento foi transferido para você!');
                }

                // // se existir algum array manual em memória, atualiza
                // const holdIndex = (sessionStore.holdSessions as any)?.findIndex((s: any) => Number(s.id) === session.id);
                // if (holdIndex !== -1) {
                //     (sessionStore.holdSessions as any).splice(holdIndex, 1);
                // }
                //
                // const activeSessions = (sessionStore as any).activeSessions;
                // if (Array.isArray(activeSessions)) {
                //     const activeIndex = activeSessions.findIndex((s: any) => Number(s.id) === session.id);
                //     if (activeIndex === -1) {
                //         activeSessions.push({
                //             ...session,
                //             status: "active",
                //             is_archive: false,
                //         });
                //     }
                // }

                // se a session estava aberta, limpa estado
                if (wasSelected) {
                    sessionStore.clearSession();
                    store.activeSidebarComponent = "active";
                }
            } catch (e) {
                console.error("❌ erro TransferSessionEvent listener", e);
            }
        });
};